import React from 'react';
import styled, { css } from 'react-emotion';
import PropTypes from 'prop-types';

import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import { Box } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import ExternalLink from '~/modules/coreUI/components/basic/ExternalLink';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';

const IconWrapper = withDirection(styled(Box)`
  position: fixed;
  bottom: ${props => 7 * props.theme.new.spacer}px;
  z-index: 10;
  ${props => (props.direction === 'rtl'
    ? css`
        left: ${1.5 * props.theme.new.spacer}px;
      `
    : css`
        right: ${1.5 * props.theme.new.spacer}px;
  `)}
  width: ${props => 5.6 * props.theme.new.spacer}px;
  height: ${props => 5.6 * props.theme.new.spacer}px;
  background-color: ${props => props.theme.colors.primary};
  &:hover {
    background-color: ${props => props.theme.colors.primaryHover};
  }
  &:active {
    background-color: ${props => props.theme.colors.primaryClicked};
  }
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border-radius:  ${props => props.theme.borders.radius.normal}px;
  ${props => cssMediaMax.xsmall`
    width: ${4 * props.theme.new.spacer}px;
    height: ${4 * props.theme.new.spacer}px;
    bottom: ${props.theme.new.spacer}px;
    ${props.direction === 'rtl'
    ? css`
        left: ${props.theme.new.spacer}px;
      `
    : css`
        right: ${props.theme.new.spacer}px;
    `}
  `}
`);
const Icon = styled.i`
  font-size: 42px;
  color: ${props => props.theme.colors.named.white};
  ${cssMediaMax.xsmall`
    font-size: 26px;
  `}
`;

const FloatingIcon = ({ url, title }) => (
  <ExternalLink title={title} url={url}>
    <IconWrapper centerJustified centerAligned>
      <Icon className="el-icon el-icon-ask" />
    </IconWrapper>
  </ExternalLink>
);

FloatingIcon.defaultProps = {
  title: '',
};

FloatingIcon.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default FloatingIcon;
